export enum CLOUD_PLATFORM {
  AWS = 'aws',
  GCP = 'gcp',
  AZURE = 'azure',
}
